import { render, staticRenderFns } from "./DelegationProfile.vue?vue&type=template&id=7f756074&scoped=true&"
import script from "./DelegationProfile.vue?vue&type=script&lang=ts&"
export * from "./DelegationProfile.vue?vue&type=script&lang=ts&"
import style0 from "./DelegationProfile.vue?vue&type=style&index=0&id=7f756074&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f756074",
  null
  
)

export default component.exports